import { useEffect, useState } from "react";
import { api } from "./api";
import { useMarket } from "./store";

export function usePortfolio(path, poll = 0) {
  const version = useMarket((s) => s.portfolioVersion);
  const [data, setData] = useState(null);
  const [tickN, setTickN] = useState(0);
  useEffect(() => {
    if (!poll) return undefined;
    const t = setInterval(() => setTickN((n) => n + 1), poll);
    return () => clearInterval(t);
  }, [poll]);
  useEffect(() => {
    let live = true;
    const t = setTimeout(() => api.get(path).then((r) => { if (live) setData(r.data); }).catch(() => {}), 150);
    return () => { live = false; clearTimeout(t); };
  }, [path, version, tickN]);
  return data;
}
